module.exports = __webpack_public_path__ + "static/media/07.b04a8fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/07.jpg
// module id = 268
// module chunks = 0